/* eslint-disable prefer-template */
export const hostIam = process.env.VUE_APP_HOST_IAM
export const hostM1 = process.env.VUE_APP_HOST_M1
export const hostM2 = process.env.VUE_APP_HOST_M2
export const hostM3 = process.env.VUE_APP_HOST_M3
export const hostM4 = process.env.VUE_APP_HOST_M4

export const hostIamV2 = process.env.VUE_APP_HOST_IAM_V2
export const hostM1V2 = process.env.VUE_APP_HOST_M1_V2

export const hostConfiguration = process.env.VUE_APP_HOST_GLOBAL_CONFIG

export const hostNoti = process.env.VUE_APP_HOST_NOTI

export const apiPath = {
  //
  // IMS
  //
  site: "/sites/dropdown",
  profile: {
    base: "/me",
    changePassword: "/me/change-password",
  },

  //
  // M1 User (New)
  //
  getAllUserList: hostM1 + "/users/list",
  generateUserCustomer: hostM1 + "/users/generate-customer",

  getWorkloadList: hostM1 + "/workloads",

  getUserPreferences: hostM1 + "/user-preferences",
  updateUserPreferences: hostM1 + "/user-preferences",

  //
  // M1 V2 (New)
  //
  getSiteLocationList: hostM1V2 + "/idc/sites",
  getLocationBySiteId: hostM1V2 + "/idc/sites/{siteId}/locations",
  updateLocationBySiteId: hostM1V2 + "/idc/sites/{siteId}/locations",

  //
  // M2
  //
  getEquipment: hostM2 + "/equipment",
  getEquipmentById: hostM2 + "/equipment/",
  getTags: hostM2 + "/tags",
  getDiscoveryBySubnet: hostM2 + "/discovery",
  addEquipment: hostM2 + "/equipment",
  updateTagListByEquipmentId: hostM2 + "/equipment/",
  updateTagList: hostM2 + "/equipment/tags",
  disablePolicyMonitoringByEquipmentId: hostM2 + "/equipment/",
  disableMultiplePolicyMonitoring: hostM2 + "/equipment/monitoring/disable",
  updatePolicyByEquipmentId: hostM2 + "/equipment/",
  updatePolicyMultipleEquipment: hostM2 + "/equipment/policy",
  deleteEquipment: hostM2 + "/equipment",
  // policy
  getPolicyName: hostM2 + "/policy-management/names",
  getCredentialsSnmp: hostM2 + "/credentials/snmp",
  getCredentialsWmi: hostM2 + "/credentials/wmi",
  addCredentialsSnmp: hostM2 + "/credentials/snmp",
  addCredentialsWmi: hostM2 + "/credentials/wmi",
  deleteCredentialsSnmp: hostM2 + "/credentials/snmp/",
  deleteCredentialsWmi: hostM2 + "/credentials/wmi/",
  getPolicyManagementUnits: hostM2 + "/policy-management/units",
  addPolicyManagement: hostM2 + "/policy-management",
  getPolicyManagement: hostM2 + "/policy-management",
  getPolicyManagementById: hostM2 + "/policy-management/",
  updatePolicyManagementById: hostM2 + "/policy-management/",
  checkPolicyManagementById: hostM2 + "/policy-management/",
  deletePolicyManagementById: hostM2 + "/policy-management/",
  getResourceTypes: hostM2 + "/policy-management/types",
  // alert
  getAlertManagement: hostM2 + "/alert-management/alerts",
  getAlertManagementById: hostM2 + "/alert-management/alerts/",
  enableAlertManagementById: hostM2 + "/alert-management/alerts/",
  getAlertManagementEquipment: hostM2 + "/alert-management/alerts/equipments",
  addAlertManagement: hostM2 + "/alert-management/alerts",
  updateAlertManagementById: hostM2 + "/alert-management/alerts/",
  deleteAlertManagementById: hostM2 + "/alert-management/alerts/",
  // dashboard
  getDashboardCpu: hostM2 + "/dashboard/cpu",
  getDashboardMemory: hostM2 + "/dashboard/memory",
  getDashboardStorage: hostM2 + "/dashboard/storage",
  getDashboardEquipmentResource: hostM2 + "/dashboard/equipment",
  // event
  getEvents: hostM2 + "/events",
  getHostname: hostM2 + "/events/hostnames",
  // report
  getReport: hostM2 + "/report",
  exportReport: hostM2 + "/report/download",

  //
  // IAM Module
  //
  getUsersMeByUsername: hostIam + "/users/me",
  updateDepartmentList: hostIam + "/departments",
  getStaffList: hostIam + "/staffs",
  getStaffListV2: hostIamV2 + "/staffs",
  getAllStaffList: hostIamV2 + "/staffs/list",
  authentication: hostIam + "/auth",
  getUserPermissions: hostIam + "/permissions",

  // Check Is Token Available
  checkIsTokenAvailable: hostIam + "/users/me",
  // Change Password
  changePassword: hostIam + "/users/change-password",

  // ? V2
  getUserList: hostIamV2 + "/users/list",

  //
  // Global Configuration
  //
  getSettings: hostConfiguration + "/configurations/",
  updateSettings: hostConfiguration + "/configurations/",
  getMonitoring: hostConfiguration + "/configurations/monitoring",

  // Customer Permission
  getCustomerPermission: hostM1 + "/permissions/customer",
  updateCustomerPermission: hostM1 + "/permissions/customer",

  /* MULTI-SITE ACCESS */
  getSiteList: hostM1V2 + "/idc/sites/list",
  getSiteDetailById: hostM1 + "/idc/sites/{siteId}",
  getAllDepartmentList: hostM1 + "/idc/departments/list",
  getDepartmentListBySiteId: hostM1 + "/idc/sites/{siteId}/departments",

  //
  // Web Portal Module
  //

  /* Dashboard */
  getNewEntry: {
    ticket: hostM1 + "/dashboard/ticket/new-entry",
    siteAccess: hostM1 + "/dashboard/site-access/new-entry",
    smartHand: hostM1 + "/dashboard/smart-hand/new-entry",
    parcel: hostM1 + "/dashboard/parcel/new-entry",
    xConnect: hostM1 + "/dashboard/cross-connect/new-entry",
  },

  getRecentEntry: {
    ticket: hostM1 + "/dashboard/ticket/recent-entry",
    siteAccess: hostM1 + "/dashboard/site-access/recent-entry",
    smartHand: hostM1 + "/dashboard/smart-hand/recent-entry",
    parcel: hostM1 + "/dashboard/parcel/recent-entry",
    xConnect: hostM1 + "/dashboard/cross-connect/recent-entry",
    escalation: hostM1 + "/dashboard/escalation/recent-entry",
  },

  getStat: {
    ticket: hostM1 + "/dashboard/ticket/stat",
    siteAccess: hostM1 + "/dashboard/site-access/stat",
    smartHand: hostM1 + "/dashboard/smart-hand/stat",
    parcel: hostM1 + "/dashboard/parcel/stat",
    xConnect: hostM1 + "/dashboard/cross-connect/stat",
    contract: hostM1 + "/dashboard/ntdc/stat",
  },

  getNewEntryStat: hostM1 + "/dashboard/new-entry-stat",

  getMaDate: hostM1 + "/dashboard/inventory/ma",

  getIdcDatabase: hostM1 + "/dashboard/idc/data",

  getExecutiveTicketStat: hostM1 + "/dashboard/executive/ticket/stat",
  getExecutiveTicketCriticalEntry:
    hostM1 + "/dashboard/executive/ticket/critical-entry",
  getExecutiveTicketEscalation:
    hostM1 + "/dashboard/executive/escalation/recent-entry",
  getExecutiveTicketRecentEntry:
    hostM1 + "/dashboard/executive/ticket/recent-entry",
  getExecutiveNewEntryStat: hostM1 + "/dashboard/executive/new-entry-stat",

  /* TICKET */
  // Get Ticket List
  getTicketList: hostM1 + "/tk/tickets",
  getExternalTicketList: hostM1 + "/external/tk/tickets",
  // Get Ticket by Id
  getTicketById: hostM1 + "/tk/tickets/",
  getExternalTicketById: hostM1 + "/external/tk/tickets/",
  // Get Topic List
  getTopicList: hostM1 + "/tk/topics",
  // Get Topic by Id
  getTopicById: hostM1 + "/tk/topics/",
  getExternalTopicList: hostM1 + "/external/tk/topics",
  getExternalTopicById: hostM1 + "/external/tk/topics/",
  // Create New Ticket Topic
  createNewTicketTopic: hostM1 + "/tk/topics",
  // Update Ticket Topic
  updateTicketTopic: hostM1 + "/tk/topics/{ticketTopicId}",
  // Create ticket
  createNewTicket: hostM1 + "/tk/tickets",
  createNewExternalTicket: hostM1 + "/external/tk/tickets",
  // Upload Attachment
  uploadTicketAttachments: hostM1 + "/tk/tickets/",
  uploadExternalTicketAttachments: hostM1 + "/external/tk/tickets/",
  // Delete ticket by Id
  deleteTicketById: hostM1 + "/tk/tickets/",
  deleteExternalTicketById: hostM1 + "/external/tk/tickets/",
  // Delete ticket attachment by ticket ID and attachment ID
  deleteTicketAttachment:
    hostM1 + "/tk/tickets/{ticketId}/attachments/{attachmentId}",
  // Delete external ticket attachment by ticket ID and attachment ID
  deleteExternalTicketAttachment:
    hostM1 + "/external/tk/tickets/{ticketId}/attachments/{attachmentId}",
  // Get Thread by TicketId
  getThreadByTicketId: hostM1 + "/tk/tickets/",
  getExternalThreadByTicketId: hostM1 + "/external/tk/tickets/",
  // Update Ticket by Id
  updateTicketById: hostM1 + "/tk/tickets/",
  // Add Thread by TicketId
  addThreadByTicketId: hostM1 + "/tk/tickets/",
  addExternalThreadByTicketId: hostM1 + "/external/tk/tickets/",
  // Upload Attachment of Thread
  uploadThreadAttachments: hostM1 + "/tk/tickets/",
  uploadExternalThreadAttachments: hostM1 + "/external/tk/tickets/",
  deleteThreadAttachment:
    hostM1 +
    "/tk/tickets/{ticketId}/threads/{threadId}/attachments/{attachmentId}",
  deleteExternalThreadAttachment:
    hostM1 +
    "/external/tk/tickets/{ticketId}/threads/{threadId}/attachments/{attachmentId}",
  // Reply Template
  replyTemplates: hostM1 + "/tk/reply-templates",
  replyTemplateById: hostM1 + "/tk/reply-templates/",
  createNewReplyTemplate: hostM1 + "/tk/reply-templates",
  updateReplyTemplate: hostM1 + "/tk/reply-templates/{templateId}",

  /* SITE ACCESS */

  // Reject Qr
  rejectQr: hostM1 + "/qr/qr-accesses/",

  // Create new Site access
  createNewSiteAccess: hostM1 + "/sa/site-accesses/",
  createExternalSiteAccess: hostM1 + "/external/sa/site-accesses/",
  // Get site access by id for external
  getExternalSiteAccessById:
    hostM1 + "/external/sa/site-accesses/{siteAccessId}",
  updateExternalSiteAccessById:
    hostM1 + "/external/sa/site-accesses/{siteAccessId}",
  deleteExternalSiteAccessById:
    hostM1 + "/external/sa/site-accesses/{siteAccessId}",
  addExternalAttachmentById:
    hostM1 + "/external/sa/site-accesses/{siteAccessId}/attachments",
  editExternalAttachmentById:
    hostM1 +
    "/external/sa/site-accesses/{siteAccessId}/attachments/{attachmentId}",
  deleteExternalAttachmentById:
    hostM1 +
    "/external/sa/site-accesses/{siteAccessId}/attachments/{attachmentId}",
  getExternalVisitorsById:
    hostM1 + "/external/sa/site-accesses/visitors/{siteAccessId}",

  addAttachmentById: hostM1 + "/sa/site-accesses/{siteAccessId}/attachments",
  editAttachmentById:
    hostM1 + "/sa/site-accesses/{siteAccessId}/attachments/{attachmentId}",
  deleteAttachmentById:
    hostM1 + "/sa/site-accesses/{siteAccessId}/attachments/{attachmentId}",

  // Site access by id for internal
  getSiteAccessById: hostM1 + "/sa/site-accesses/{siteAccessId}",
  updateSiteAccessById: hostM1 + "/sa/site-accesses/{siteAccessId}",
  deleteSiteAccessById: hostM1 + "/sa/site-accesses/{siteAccessId}",
  getVisitorsById: hostM1 + "/sa/site-accesses/visitors/{siteAccessId}",
  updateSiteAccessStatusById:
    hostM1 + "/sa/site-accesses/{siteAccessId}/status",
  resendEmail: hostM1 + "/sa/site-accesses/resend-email",

  // Site Access Dashboard
  getTodayStatusCount: hostM1 + "/sa/dashboard/access-status",
  getTodaySiteAccessStatus: hostM1 + "/sa/dashboard/status-ratio",
  getTodaySelfCheckIn: hostM1 + "/sa/dashboard/daily-check-in",
  getTodaySiteApproved: hostM1 + "/sa/dashboard/upcoming",
  getTodaySiteAccess: hostM1 + "/sa/dashboard/accessing",
  getPastSiteAccess: hostM1 + "/sa/dashboard/request-expired",

  /* PARCEL TRACKING */
  // Get Parcel List
  getParcelList: hostM1 + "/pt/parcels",
  // Get Parcel by Id
  getParcelById: hostM1 + "/pt/parcels/",
  // Receive Parcel by Id
  receiveParcel: hostM1 + "/pt/parcels/",
  // Create Parcel
  createNewParcel: hostM1 + "/pt/parcels",
  // Delete Parcel by Id
  deleteParcel: hostM1 + "/pt/parcels/",
  // Update Parcel by Id
  updateParcel: hostM1 + "/pt/parcels/",

  /* Services */
  // Get All Service Package
  getAllServices: hostM1 + "/idc/services",
  // Toggle Service Deprecated
  toggleServiceDeprecated: hostM1 + "/idc/services/{serviceId}/deprecated",
  // Toggle Package Deprecated
  togglePackageDeprecated:
    hostM1 + "/idc/services/{serviceId}/packages/{packageId}/deprecated",
  // Update Service Detail
  updateServiceDetail: hostM1 + "/idc/services/{serviceId}",
  // Add Service
  addService: hostM1 + "/idc/services/",
  // Get Services Name
  getServicesName: hostM1 + "/idc/services/names",
  // Get Services by Id
  getServiceById: hostM1 + "/idc/services/",
  // Delete Service by Id
  deleteServiceById: hostM1 + "/idc/services/",
  // edit service name by id
  updateServiceName: hostM1 + "/idc/services/",
  // Get Package Name List by Service Id
  getPackageNameListByServiceId:
    hostM1 + "/idc/services/{serviceId}/packages/names",
  // Get service and package detail by id
  getServiceAndPackageDetailById:
    hostM1 + "/idc/services/{serviceId}/packages/{packageId}",
  getServiceAndPackageNameList: hostM1 + "/idc/services/service-package-names",

  /* Contract */
  // Get Contract Name List
  getContractNameList: hostM1V2 + "/idc/contracts/names",
  // Get Contract by Id
  getContractByIdcId: hostM1V2 + "/idc/contracts/",
  // Get Contract List
  getContractList: hostM1V2 + "/idc/contracts",
  // Create new contract
  createNewContract: hostM1V2 + "/idc/contracts",
  // Get Form List
  getFormList: hostM1 + "/idc/contracts/forms",
  // Get Contact Point Form
  getContactPointForm: hostM1 + "/idc/contracts/{contractId}/forms/{formId}",
  // Change Contract Status
  changeContractStatus: hostM1 + "/idc/contracts/{contractId}/status",
  // Get Contract Note
  getContractNote: hostM1 + "/idc/contracts/{contractId}/notes",
  // Create New Contract Note
  createNewContractNote: hostM1 + "/idc/contracts/{contractId}/notes",
  // Delete Contract Note
  deleteContractNote: hostM1 + "/idc/contracts/{contractId}/notes/{noteId}",
  // Update Contract
  updateContractById: hostM1V2 + "/idc/contracts/{contractId}",
  // Upload Contract Attachment
  uploadContractAttachment:
    hostM1V2 + "/idc/contracts/{contractId}/attachments",
  // Upload Contract Attachment
  editContractAttachment:
    hostM1V2 + "/idc/contracts/{contractId}/attachments/{attachmentId}",
  // Delete Contract Attachment
  deleteContractAttachment:
    hostM1V2 + "/idc/contracts/{contractId}/attachments/{attachmentId}",
  // Get Contract Status Count
  getContractStatusCount: hostM1 + "/idc/contracts/stat",

  /* Business Type */
  // Get Business Type List
  getBusinessTypeList: hostM1 + "/idc/business-types",

  /* Contact Point and Sale */
  // Create new contact point
  createContactPointOrSale: hostM1 + "/idc/contact-points",
  // Update profile picture
  updateProfilePicture: hostM1 + "/idc/contact-points/{contactPointId}/photo",
  // Get Contact Point and Sale Name List
  getContactPointAndSaleNameList: hostM1 + "/idc/contact-points/names",
  // Get Contact Point or Sale Detail (phone, email option)
  getContactPointOrSaleDetailById:
    hostM1 + "/idc/contact-points/{contactPointId}",
  // Get Contact Point and Sale List
  getContactPointAndSaleList: hostM1 + "/idc/contact-points",
  // Update Contact Point or Sale Detail
  updateContactPointOrSale: hostM1 + "/idc/contact-points/{contactPointId}",

  /* Customer */
  // Create new customer
  createNewCustomer: hostM1 + "/idc/customers",
  // Get customer list
  getCustomerList: hostM1 + "/idc/customers",
  // Get Customer Name List
  getCustomerNameList: hostM1 + "/idc/customers/names",
  // Get customer detail by id
  getCustomerDetailById: hostM1 + "/idc/customers/{customerId}",
  // Update customer detail
  updateCustomerDetail: hostM1 + "/idc/customers/{customerId}",

  /* Location */
  // Get location list
  getLocationList: hostM1V2 + "/idc/locations",

  /* Inventory */
  getInventoryStat: hostM1 + "/in/inventories/stats",
  getInventory: hostM1 + "/in/inventories",
  getInventoryById: hostM1 + "/in/inventories/",
  updateInventoryById: hostM1 + "/in/inventories/",
  createInventory: hostM1 + "/in/inventories",
  deleteInventoryById: hostM1 + "/in/inventories/",

  /* Smart Hand */
  getSmartHands: hostM1 + "/sh/smart-hands",
  getSmartHandsById: hostM1 + "/sh/smart-hands/",
  createSmartHands: hostM1 + "/sh/smart-hands",
  updateSmartHandsById: hostM1 + "/sh/smart-hands/",
  deleteSmartHandsById: hostM1 + "/sh/smart-hands/",
  uploadSmartHandsAttachments:
    hostM1 + "/sh/smart-hands/{smartHandId}/attachments",
  deleteSmartHandAttachment:
    hostM1 + "/sh/smart-hands/{smartHandId}/attachments/{attachmentId}",

  updateSmartHandsAction: hostM1 + "/sh/smart-hands/{smartHandId}/actions",
  getSmartHandsAction: hostM1 + "/sh/smart-hands/{smartHandId}/actions",
  updateStaffAction: hostM1 + "/sh/smart-hands/{smartHandId}/staff",
  uploadSmartHandsAdminAttachment:
    hostM1 + "/sh/smart-hands/{smartHandId}/actions/{actionId}/attachments",
  deleteSmartHandActionAttachment:
    hostM1 +
    "/sh/smart-hands/{smartHandId}/actions/{actionId}/attachments/{attachmentId}",

  /* Cross Connect */
  getCrossConnect: hostM1 + "/xc/cross-connects",
  createCrossConnect: hostM1 + "/xc/cross-connects",
  getCrossConnectById: hostM1 + "/xc/cross-connects/",
  updateCrossConnectById: hostM1 + "/xc/cross-connects/",
  deleteCrossConnect: hostM1 + "/xc/cross-connects/",
  uploadCrossConnectAttachments:
    hostM1 + "/xc/cross-connects/{crossConnectId}/attachments",
  deleteCrossConnectAttachment:
    hostM1 + "/xc/cross-connects/{crossConnectId}/attachments/{attachmentId}",
  getCrossConnectInternalById:
    hostM1 + "/xc/cross-connects/{crossConnectId}/staff",
  updateCrossConnectStatus:
    hostM1 + "/xc/cross-connects/{crossConnectId}/status",

  createCrossConnectMessage:
    hostM1 + "/xc/cross-connects/{crossConnectId}/actions",
  updateCrossConnectStaffAction:
    hostM1 + "/xc/cross-connects/{crossConnectId}/staff",

  uploadCrossConnectInternalAttachment:
    hostM1 +
    "/xc/cross-connects/{crossConnectId}/actions/{actionId}/attachments",

  /* IPAM */
  // Get Subnet Address List
  getSubnetList: hostM1 + "/ipam/subnets",
  // Get Subnet Options (for filter)
  getSubnetOptions: hostM1 + "/ipam/subnets/list",
  // Get Subnet Tag List
  getSubnetAndIpTagList: hostM1 + "/ipam/tags",
  // Get Subnet IP Address List By Id
  getSubnetIpAddressById: hostM1 + "/ipam/subnets/{subnetId}/ips",
  // Add New Subnet
  addNewSubnet: hostM1 + "/ipam/subnets",
  // Delete Subnet
  deleteSubnet: hostM1 + "/ipam/subnets/{id}",
  // Edit Subnet
  editSubnet: hostM1 + "/ipam/subnets/{id}",
  // Override Tags to Ip
  overrideTagsToIp: hostM1 + "/ipam/subnets/{id}/overwrite-ip-tags",
  // Edit Ip Address
  editIpAddress: hostM1 + "/ipam/subnets/{subnetId}/ips/{ip}",
  // Edit Multiple Ip Address
  editMultipleIpAddress: hostM1 + "/ipam/subnets/{subnetId}/ips",
  // Add New Ip Address (available only IPv6)
  addNewIpAddress: hostM1 + "/ipam/subnets/{subnetId}/ips",
  // Delete Ip Address (available only IPv6)
  deleteIpAddress: hostM1 + "/ipam/subnets/{subnetId}/ips/{ip}",
  // Delete Multiple Ip Addresses (available only IPv6)
  deleteMultipleIpAddress: hostM1 + "/ipam/subnets/{subnetId}/ips",

  /* REPORT */
  exportReportWebPortal: hostM1 + "/report/",
  previewReportWebPortal: hostM1 + "/report/preview/",

  /* SHARED ATTACHMENTS */
  getAttachments: hostM1 + "/attachments",

  /* SHARED TAGS */
  getSharedTags: hostM1 + "/tags",

  /* EXTERNAL CONTRACT */
  // get external contracts
  getExternalContractsById: hostM1 + "/external/idc/contracts/my-contract",

  // ? V2
  // get ipam subnets list
  getIpamSubnetsList: hostM1V2 + "/ipam/subnets/list",
  // delete contracts attachments
  deleteContractAttachmentsById:
    hostM1V2 + "/idc/contracts/{contractId}/attachments/{attachmentId}",

  //
  // M3
  //

  /* DASHBOARD */
  // Get Dashboard
  getDashboard: hostM3 + "/dashboards",

  /* SERVER */
  // Get All Server in Veeam server
  getVeeamServer: hostM3 + "/managedServers",
  // Add Server
  addVeeamServer: hostM3 + "/managedServers",
  // Edit Server
  editVeeamServer: hostM3 + "/managedServers/",
  // Delete Server
  deleteVeeamServer: hostM3 + "/managedServers/",

  /* REPOSITORY */
  // Get All Repository
  getRepositoryList: hostM3 + "/repositories",
  getRepositoryStatusList: hostM3 + "/repositories/states",
  // Get Repository By Id
  getRepositoryById: hostM3 + "/repositories/",
  // Create Repository
  createRepository: hostM3 + "/repositories",
  // Update Repository
  updateRepository: hostM3 + "/repositories/",
  // Delete Repository
  deleteRepository: hostM3 + "/repositories/",

  /* CREDENTIAL */
  // Get All Credential in Veeam server
  getVeeamCredential: hostM3 + "/credentials",
  // Edit Credential
  editVeeamCredential: hostM3 + "/credentials/",
  // Change Password
  changePasswordVeeamCredential: hostM3 + "/credentials/{id}/change-password",
  changeRootPasswordVeeamCredential:
    hostM3 + "/credentials/{id}/change-root-password",
  // Delete Credential
  deleteVeeamCredential: hostM3 + "/credentials/",

  /* VEEAM */
  // Get All Veeam
  getVeeamList: hostM3 + "/veeams",
  // Add Veeam
  addVeeam: hostM3 + "/veeams",
  // Edit Veeam
  editVeeam: hostM3 + "/veeams/",
  // Delete Veeam
  deleteVeeam: hostM3 + "/veeams/",

  /* JOB */
  // Get Job
  getJobs: hostM3 + "/jobs",
  // Get Job States (Backup Management table)
  getJobsStates: hostM3 + "/jobs/states",
  getJobsStatesById: hostM3 + "/jobs/states/",
  // Delete Job
  deleteJob: hostM3 + "/jobs/",

  // Get Backup By ID
  getBackupById: hostM3 + "/jobs/",
  // Create Backup
  createVeeamBackup: hostM3 + "/jobs",
  // Update Backup
  updateVeeamBackup: hostM3 + "/jobs/",
  // Delete Backup
  deleteVeeamBackup: hostM3 + "/jobs/",
  // Start Backup
  startVeeamBackup: hostM3 + "/jobs/{id}/start",
  // Stop Backup
  stopVeeamBackup: hostM3 + "/jobs/{id}/stop",
  // Disable Backup
  disableVeeamtBackup: hostM3 + "/jobs/{id}/disable",
  // Enable Backup
  enableVeeamBackup: hostM3 + "/jobs/{id}/enable",

  /* INVENTORY */
  // Get Inventory browsers
  getInventoryBrowsers: hostM3 + "/inventory-browsers",
  // VM Inventory
  vmInventory: hostM3 + "/inventory-browsers/",

  /* Restore */
  // Get Restore Point
  getRestorePoint: hostM3 + "/restores/restore-points",
  restoreEntireVm: hostM3 + "/restores/vmRestore/vSphere",

  /* Backup */
  // Get Back up
  getBackupObject: hostM3 + "/backups",

  //
  // M4
  //

  /* CREDENTIALS */
  // Add Credentials
  addSnmp: hostM4 + "/credentials/snmp",
  addRemote: hostM4 + "/credentials/remote",
  // Get Credentials
  getSnmpList: hostM4 + "/credentials/snmp",
  getRemoteList: hostM4 + "/credentials/remote",
  getSnmpById: hostM4 + "/credentials/snmp/",
  getRemoteById: hostM4 + "/credentials/remote/",
  // Update Credentials
  updateSnmpById: hostM4 + "/credentials/snmp/",
  updateRemoteById: hostM4 + "/credentials/remote/",
  // Delete Credentials
  deleteSnmpById: hostM4 + "/credentials/snmp/",
  deleteRemoteById: hostM4 + "/credentials/remote/",

  /* AUTO BACKUP CONFIG */
  // Get Auto Backup Config List
  getAutoBackupConfigList: hostM4 + "/auto-backup-configs",
  // Get Auto Backup Config By Id
  getAutoBackupConfigDetailById: hostM4 + "/auto-backup-configs/{id}",
  // Delete Auto Backup Config List
  deleteAutoBackupConfig: hostM4 + "/auto-backup-configs/{id}",
  // Create New Auto Backup Config
  createAutoBackupConfig: hostM4 + "/auto-backup-configs",
  // Edit Auto Backup Config
  editAutoBackupConfig: hostM4 + "/auto-backup-configs/{id}",

  /* NODES */
  // Discovery by subnet
  discoveryBySubnet: hostM4 + "/nodes/discovery",
  // Add Nodes
  addNodes: hostM4 + "/nodes",
  // Get Node List
  getNodeList: hostM4 + "/nodes",
  // Get Node Detail By Id
  getNodeDetailById: hostM4 + "/nodes/{id}",
  // Get Config Change Trend Graph (By NodeId)
  getConfigChangeTrendGraph: hostM4 + "/nodes/{id}/config-change-trends",
  // Update Node Tags (Single)
  updateNodeTag: hostM4 + "/nodes/{id}/tags",
  // Update Nodes Tags (Multiple)
  updateNodesTags: hostM4 + "/nodes/tags",
  // Update Nodes SNMP Credential
  updateNodesSnmp: hostM4 + "/nodes/snmp-credential",
  // Update Nodes Remote Credential
  updateNodesRemote: hostM4 + "/nodes/remote-credential",
  // Delete Nodes
  deleteNodes: hostM4 + "/nodes",

  /* TAGS */
  getTagsList: hostM4 + "/tags",

  /* TEMPLATES */
  // Get Template List
  getTemplateList: hostM4 + "/templates",
  // Get Template By Id
  getTemplateById: hostM4 + "/templates/",
  // Create Template
  createTemplate: hostM4 + "/templates",
  // Update Template
  updateTemplate: hostM4 + "/templates/",
  // Delete Template
  deleteTemplate: hostM4 + "/templates/",
  // Generate Template
  generateTemplate: hostM4 + "/templates/",

  /* CONFIGURATION CHANGE */
  // Get Config Change
  getConfigurationChangeList: hostM4 + "/configurations/changes",
  // Get Config Change Version List
  getConfigurationChangeVersion: hostM4 + "/configurations/changes/{nodeId}",
  // Get Config Change Version with Datetime
  getConfigVersionWithTimestamp:
    hostM4 + "/configurations/changes/{nodeId}/versions",
  // Get Node Configuration by NodeId and Version
  getNodeConfigurationDetail:
    hostM4 + "/configurations/changes/{nodeId}/{changeVersion}",
  // Export all latest configuration
  exportLatestConfiguration: hostM4 + "/configurations/latest-changes/export",

  /* ESCALATION */
  getTicketEscalationList: hostM1 + "/tk/escalations",
  getTicketEscalationById: hostM1 + "/tk/escalations/{id}",
  updateTicketEscalationById: hostM1 + "/tk/escalations/{id}",
  ticketEscalationCreate: hostM1 + "/tk/escalations",
  deleteTicketEscalation: hostM1 + "/tk/escalations/",
  getTicketEscalationActiveList: hostM1 + "/tk/escalations/active",

  getEscalationEventList: hostM1 + "/tk/escalation-events",

  getTicketEscalationByTicketId: hostM1 + "/tk/tickets/{ticketId}/escalation",
  escalateTicketEscalationByTicketId:
    hostM1 + "/tk/tickets/{ticketId}/escalation/escalate",

  //
  // Notification
  //
  getNotiConfig: hostNoti + "notifications/config",
  getNoti: hostNoti + "notifications/me",
  updateNotiStatusToSeen: hostNoti + "notifications/seen",
  updateNotiStatusToRead: hostNoti + "notifications/read",

  /* Site-Access*/
  getSiteAccessList: hostM1 + "/sa/site-accesses",
  getSiteAccessVisitors: hostM1 + "/sa/site-accesses/visitors",
  getExternalSiteAccessList: hostM1 + "/external/sa/site-accesses",
  getExternalSiteAccessVisitors: hostM1 + "/external/sa/site-accesses/visitors",
  // Self Check-in
  getAvailableCheckInList: hostM1 + "/sa/site-accesses/pre-check-in",
  uploadVisitorImage: hostM1 + "/sa/site-accesses/image",
  visitorCheckIn: hostM1 + "/sa/site-accesses/check-in",
}
